import React from 'react';
import {
    Responsive,
    SimpleList,
    Datagrid,
    TextField,
} from 'admin-on-rest';
import List from '../admin/List';
import POSUserTypePermissionsList from '../components/POSUserTypePermissionsList';
import {viewStyles} from '../shared/styles-view';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/action/supervisor-account';

export const fusePosUserTypeIcon = Icon;

/*
 * View: List
 */

// Set title for List POS User Types
const ListTitle = <span><Avatar icon={<Icon/>} style={viewStyles.avatar} className="avatar-title"/>POS User Types</span>;

const ListDescription = () => {
    return (
        <Card>
            <CardHeader
                subtitle="POS User Types are assigned to POS Users to give them specific permissions on the POS System. Expand to read more."
                actAsExpander={true}
                showExpandableButton={true}
            />
            <CardText expandable={true}>
                <POSUserTypePermissionsList/>
            </CardText>
        </Card>
    );
};

export const fusePosUserTypeList = (props) => (
    <List {...props} title={ListTitle} desc={<ListDescription/>} sort={{field: 'level', order: 'DESC'}}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.name}
                    tertiaryText={record => record.level}
                />
            }
            medium={
                <Datagrid bodyOptions={{stripedRows: false, showRowHover: true}}>
                    <TextField source="name"/>
                    <TextField source="level"/>
                </Datagrid>
            }
        />
    </List>
);



// WEBPACK FOOTER //
// ./src/Fuse/User/posUserType.js